import React from "react";
import { socialList } from "../utils/data";
const Contact = () => {
  return (
    <div className="contact">
      <div className="container py-10  md:py-20">
        <div className="bg-primary p-8 md:p-10 rounded-2xl py-10 md:py-14">
          <h1 className="font-bold text-[30px] md:text-[60px] uppercase text-center max-w-2xl mx-auto text-primary-text">
            Join our Community
          </h1>
          <div className="grid grid-flow-col mt-10 justify-center  gap-6 text-primary-text uppercase ">
            {socialList.map((value, index) => (
              <div
                key={index}
                className="text-center flex justify-center flex-col items-center "
              >
                <a
                  href={value.link}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[30px] md:text-[60px] block mb-4 "
                >
                  {value.icon}
                </a>
                <p className="text-xs md:text-base">{value.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
